<template>
    <div class="card">
        <!-- <TabView @tab-change="handleTabChange"> -->
        <TabView>
            <TabPanel header="รายงานเหตุเพลิงไหม้ (ว.๘/๐๐๑)">
                <report-daily-fire></report-daily-fire>
            </TabPanel>
            <TabPanel header="รายงานเหตุสาธารณภัยและบริการประชาชน">
                <report-daily-disaster></report-daily-disaster>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import reportDailyFire from './ReportDailyFire';
import reportDailyDisaster from './ReportDailyDisaster';

export default {
    components: {
        reportDailyFire,
        reportDailyDisaster
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>